import React from 'react';
import { observer } from 'mobx-react';

import { BrandData } from 'src/api';
import { ClientDataStore } from '../../stores/client-data.store';
import { lazyInject } from 'src/ioc';
import { PageFooter } from './desktop/page-footer';
import { UIStatusStore } from '../../stores/ui-status.store';

@observer
export class PageFooterContainer extends React.Component {
    @lazyInject(ClientDataStore) clientData!: ClientDataStore;
    @lazyInject(UIStatusStore) uiStatus!: UIStatusStore;

    brandData: BrandData | undefined;
    defaultUrl: string | undefined;
    showContactUs = !this.clientData.isAnonymousPayments;

    constructor(props: {}) {
        super(props);
        this.defaultUrl = this.clientData.loginData.defaultUrl;

        if (this.clientData.portalData) {
            this.brandData = this.clientData.portalData.brandData;
        }

        if (!this.defaultUrl && !this.clientData.isAnonymousPayments) {
            this.defaultUrl = '/home';
        }
    }

    handleContactUs = () => {
        this.uiStatus.isContactUsOpen = true;
    };

    render() {
        return <PageFooter container={this} />;
    }
}
